import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-marquee-notification-modal',
  templateUrl: './marquee-notification-modal.component.html',
  styleUrls: ['./marquee-notification-modal.component.scss'],
})
export class MarqueeNotificationModalComponent implements OnInit {
  // Tab: default tab is "general"
  activeTab: 'general' | 'maintenance' = 'general';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { contents: any[], maintenances: any[] },
    public dialogRef: MatDialogRef<MarqueeNotificationModalComponent>,
    public dialog: MatDialog,
  ) {}

  ngOnInit() {
    // If no general, default open maintenance
    if (!this.data.contents.length) {
      this.activeTab = 'maintenance';
    }
  }

  onCloseDialog() {
    this.dialogRef.close();
  }
}
